import {axiParimutuel, GetListOutput, GetListParams} from '@shared/api';
import {validateData} from '@shared/utils';
import {Stake} from '../types';
import {v8nSchemaOfGetStakesResponse} from './backendSchemas';
import {GetStakesResponse} from './backendTypes';
import {mapStakeFromBackend} from './dataMappers';

const mapStakesResponse = (data: GetStakesResponse): GetListOutput<Stake> => ({
  items: data.array.map(item => mapStakeFromBackend(item)),
  page: data.page,
  pageSize: data.per_page,
  total: data.total,
  totalPages: data.total_pages,
});

const getStakesByPath = async (
  path: string,
  {page, pageSize}: GetListParams,
  validationName: string,
): Promise<GetListOutput<Stake>> => {
  const response = await axiParimutuel.get<GetStakesResponse>(path, {
    params: {page, per_page: pageSize},
  });

  validateData(response.data, v8nSchemaOfGetStakesResponse, validationName);

  return mapStakesResponse(response.data);
};

export const getStakes = (
  params: GetListParams,
): Promise<GetListOutput<Stake>> =>
  getStakesByPath('/admin/stakes', params, 'getStakes');

export interface GetUserStakesParams extends GetListParams {
  userId: string;
}

export const getUserStakes = ({
  userId,
  ...params
}: GetUserStakesParams): Promise<GetListOutput<Stake>> =>
  getStakesByPath(`/admin/users/${userId}/stakes`, params, 'getUserStakes');

export interface GetEventStakesParams extends GetListParams {
  eventId: string;
}

export const getEventStakes = ({
  eventId,
  ...params
}: GetEventStakesParams): Promise<GetListOutput<Stake>> =>
  getStakesByPath(`/admin/events/${eventId}/stakes`, params, 'getEventStakes');

export const getPoolStakes = ({
  groupId,
  ...params
}: GetListParams & {groupId: string}): Promise<GetListOutput<Stake>> =>
  getStakesByPath(
    `/admin/pools/${encodeURIComponent(groupId)}/stakes`,
    params,
    'getPoolStakes',
  );
